// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload
      state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
      // state[config.storageRefreshTokenKeyName] = action.payload[config.storageRefreshTokenKeyName]
      localStorage.setItem('userData', JSON.stringify(action.payload))
      localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
      // localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken))
    },
    // ** Único escritor de la bandera de segundo factor. VerifyEmail escribía `userData`
    // directamente en localStorage, así que el store se quedaba con el valor viejo y ambas
    // fuentes decían cosas distintas: localStorage «ya validado», Redux «falta validar».
    // También reescribe el token: si un 401 vació localStorage durante la verificación, el código
    // se validó con el token del store y la sesión quedaría con `userData` pero sin token
    handleTwoFactorValidated: state => {
      const userData = { ...state.userData, is_required_validation: false }

      state.userData = userData
      localStorage.setItem('userData', JSON.stringify(userData))
      if (userData.accessToken) {
        localStorage.setItem(config.storageTokenKeyName, JSON.stringify(userData.accessToken))
      }
    },
    handleLogout: state => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      // state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem(config.storageTokenKeyName)
      // localStorage.removeItem(config.storageRefreshTokenKeyName)
    }
  }
})

export const { handleLogin, handleTwoFactorValidated, handleLogout } = authSlice.actions

export default authSlice.reducer
